import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "form-row" }
const _hoisted_4 = { class: "form-group col-md-6" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", null, "이메일", -1)
const _hoisted_6 = { class: "form-group col-md-6" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", null, "사용자명", -1)
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = { class: "form-group col-md-6" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", null, "회원가입 일자", -1)
const _hoisted_11 = { class: "form-group col-md-6" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", null, "최근 접속 일자", -1)
const _hoisted_13 = { class: "form-row" }
const _hoisted_14 = { class: "form-group col-md-6" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", null, "선호하는 낚시", -1)
const _hoisted_16 = { class: "form-check" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: 'Sea-check'
}, "바다", -1)
const _hoisted_18 = { class: "form-check" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", { class: "form-check-label" }, "민물", -1)
const _hoisted_20 = { class: "form-check" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { class: "form-check-label" }, "PAID_FISHING", -1)
const _hoisted_22 = { class: "form-check" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { class: "form-check-label" }, "FISHING_ON_BOARD", -1)
const _hoisted_24 = {
  key: 0,
  class: "form-group col-md-6"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("label", null, "Terminated reasons", -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createVNode("small", null, "This is no reason for this terminated user.", -1)
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_upload = _resolveComponent("file-upload")
  const _component_SubmitButton = _resolveComponent("SubmitButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("form", {
        onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitEditForm && _ctx.onSubmitEditForm(...args)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createVNode("input", {
              type: "email",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.user.email_address = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.user.email_address]
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.user.nick_name = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.user.nick_name]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createVNode("input", {
              class: "form-control",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.user.date_signup = $event)),
              type: "date"
            }, null, 512), [
              [_vModelText, _ctx.user.date_signup]
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createVNode("input", {
              class: "form-control",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.user.date_last_login = $event)),
              type: "date"
            }, null, 512), [
              [_vModelText, _ctx.user.date_last_login]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode("div", _hoisted_16, [
              _withDirectives(_createVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: 'Sea-check',
                value: 'SEA',
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.user.preferred_type = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.user.preferred_type]
              ]),
              _hoisted_17
            ]),
            _createVNode("div", _hoisted_18, [
              _withDirectives(_createVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: 'Water-check',
                value: 'WATER',
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.user.preferred_type = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.user.preferred_type]
              ]),
              _hoisted_19
            ]),
            _createVNode("div", _hoisted_20, [
              _withDirectives(_createVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: 'Paid-fishing-check',
                value: 'PAID_FISHING',
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.user.preferred_type = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.user.preferred_type]
              ]),
              _hoisted_21
            ]),
            _createVNode("div", _hoisted_22, [
              _withDirectives(_createVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: 'Fishing-on-board-check',
                value: 'FISHING_ON_BOARD',
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.user.preferred_type = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.user.preferred_type]
              ]),
              _hoisted_23
            ])
          ]),
          (_ctx.user.is_terminated)
            ? (_openBlock(), _createBlock("div", _hoisted_24, [
                _hoisted_25,
                (_ctx.user.terminated_reason.length > 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_26, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.user.terminated_reason, (item) => {
                        return (_openBlock(), _createBlock("p", {
                          key: item,
                          class: "form-control form-control-static",
                          disabled: ""
                        }, _toDisplayString(item), 1))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_27, [
                      _hoisted_28
                    ]))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_29, [
          _createVNode("div", _hoisted_30, [
            _createVNode(_component_file_upload, {
              ref: "thumbnailFile",
              title: "Avatar",
              "folder-name": 'user'
            }, null, 512)
          ])
        ]),
        _createVNode(_component_SubmitButton, {
          text: "저장",
          loadingText: " Saving...",
          isSubmitting: _ctx.isSubmitting
        }, null, 8, ["isSubmitting"])
      ], 32)
    ])
  ]))
}